import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Reusable confirm dialog.
 * Usage:
 *   const [confirm, setConfirm] = useState({ open: false, onOk: null });
 *   <ConfirmDialog {...confirm} onOpenChange={(o) => setConfirm({ ...confirm, open: o })}
 *                  title="Delete?" description="Sure?" />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Batal",
  danger = true,
  onConfirm,
  confirmDisabled = false,
  confirmClass = "",
  testid = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-none" data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display tracking-tight text-[#0B1D3A]">{title}</AlertDialogTitle>
          <AlertDialogDescription asChild><div>{description}</div></AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`} className="rounded-none">{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testid}-confirm`}
            disabled={confirmDisabled}
            className={`rounded-none ${confirmClass || (danger ? "bg-rose-600 hover:bg-rose-700 text-white" : "")} disabled:opacity-40 disabled:pointer-events-none`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
